import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/auth.service';

const RoleBasedRedirect: React.FC = () => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/signin" replace />;
  }
  if (authService.isTenant()) {
    return <Navigate to="/tenant/dashboard" replace />;
  }
  if (authService.isAgency()) {
    return <Navigate to="/agency/candidats" replace />;
  }
  // Owner or unknown role → owner dashboard
  return <Navigate to="/dashboard" replace />;
};

export default RoleBasedRedirect;
